import React from "react";
import Button from "@material-ui/core/Button";
import { I18n } from "react-redux-i18n";
import { AppBar, Badge, Checkbox, Dialog, FormControl, Icon, IconButton, InputLabel, List, ListItem, ListItemText, MenuItem, Select, TextField, Toolbar, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import { find, map, includes, join, flatMap, get, size, uniq } from "lodash";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const INCABIN_CHANNEL = {id: 3, 'channel': 2, 'name': 'page.onDemand.previouslyQueue.cameraViews.incabin'};
const initialState = {
  open: false,
  defaultCameraViewValue: [
    {id: 1, 'channel': 1, 'name': 'page.onDemand.previouslyQueue.cameraViews.forwardFacing'},
    {id: 2, 'channel': 2, 'name': 'page.onDemand.previouslyQueue.cameraViews.passenger'},
    {id: 4, 'channel': 3, 'name': 'page.onDemand.previouslyQueue.cameraViews.rear'},
    {id: 5, 'channel': 4, 'name': 'page.onDemand.previouslyQueue.cameraViews.driver'},
  ],
  defaultStatusValue: [
    {'id': 'requested', 'name': 'page.onDemand.previouslyQueue.statuses.requested'},
    {'id': 'processed', 'name': 'page.onDemand.previouslyQueue.statuses.processed'}, 
    {'id': 'completed', 'name': 'page.onDemand.previouslyQueue.statuses.completed'}, 
    {'id': 'cancelled', 'name': 'page.onDemand.previouslyQueue.statuses.cancelled'}, 
    {'id': 'expired', 'name': 'page.onDemand.previouslyQueue.statuses.expired'}, 
    {'id': 'notavailable', 'name': 'page.onDemand.previouslyQueue.statuses.notavailable'},
    {'id': 'failed', 'name': 'page.onDemand.previouslyQueue.statuses.failed'}
  ]
};

export default class MobileOnDemandFilter extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onDemandFilter: PropTypes.shape({
      vehicleValue: PropTypes.string.isRequired,
      whoRequestedValue: PropTypes.string.isRequired,
      cameraViewValue: PropTypes.array.isRequired,
      statusValue: PropTypes.array.isRequired,
    }),
    tabIndex: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);
    const {vehicleValue, whoRequestedValue, statusValue, cameraViewValue} = props.onDemandFilter;

    this.state = {
      vehicleValue,
      whoRequestedValue,
      cameraViewValue: cameraViewValue || [],
      statusValue: statusValue || [],
      localVehicleValue: vehicleValue,
      localWhoRequestedValue: whoRequestedValue,
      localCameraViewValue: cameraViewValue || [],
      localStatusValue: statusValue || [],
      tabIndex: props.tabIndex,
      showInCabinCamera: props.showInCabinCamera,
      ...initialState
    };
  }

  componentDidUpdate = (prevProps, prevState) => {  
    if (prevProps.tabIndex !== prevState.tabIndex) {
      this.setState({
        vehicleValue: "",
        whoRequestedValue: "",
        cameraViewValue: [],
        statusValue: [],
        localVehicleValue: "",
        localWhoRequestedValue: "",
        localCameraViewValue: [],
        localStatusValue: [],
        tabIndex: prevProps.tabIndex,
        showInCabinCamera: this.props.showInCabinCamera
      }, () => {
        this.filterCount();
      });
    }
    const defaultViews = [...this.state.defaultCameraViewValue];
    if(prevProps.showInCabinCamera !== this.props.showInCabinCamera){
      if(this.props.showInCabinCamera === 'true'){
        const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == "2");
        if(channel_item){
          channel_item.name = "page.onDemand.previouslyQueue.cameraViews.passengerorincabin";
        }
      }
      this.setState({defaultCameraViewValue: defaultViews});
    }
  }

  handleClear = () => {
    this.setState({
      vehicleValue: "",
      whoRequestedValue: "",
      cameraViewValue: [],
      statusValue: [],
      localVehicleValue: "",
      localWhoRequestedValue: "",
      localCameraViewValue: [],
      localStatusValue: [],
      open: false
    }, () => {
      this.props.onChange({
        vehicle: this.state.vehicleValue,
        whoRequested: this.state.whoRequestedValue,
        cameraView: this.state.cameraViewValue,
        status: this.state.statusValue,
        tabIndex: this.state.tabIndex
      });
    });
  };

  handleStatus = event => {
    this.setState({ localStatusValue: event.target.value });
  };

  handleCameraView = event => {
    this.setState({ localCameraViewValue: event.target.value, });
  }

  handleVehicle = event => {
    this.setState({ localVehicleValue: event.target.value });
  };

  handleWhoRequested = event => {
    this.setState({ localWhoRequestedValue: event.target.value });
  };

  handleOpen = () => {
    this.setState({open: true})
  };

  handleRequestClose = () => {
    this.setState({open: false});
  };

  handleOnFilter = () => {
    const cameraViewArray = this.state.localCameraViewValue.sort((a, b) => a - b);

    this.setState({
      vehicleValue: this.state.localVehicleValue,
      whoRequestedValue: this.state.localWhoRequestedValue,
      cameraViewValue: cameraViewArray,
      statusValue: this.state.localStatusValue
    }, () => {
      let statusValue = this.state.statusValue;
      if (statusValue.includes('requested')) {
        statusValue = this.handleParseRequested(statusValue);
      }
      
      this.setState({open: false});
      let camera_vals = [];
      cameraViewArray && cameraViewArray.length > 0 && cameraViewArray.forEach((cid) => {
        const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == cid);
        channel_item && camera_vals.push(channel_item.channel);
      })
      this.props.onChange({
        vehicle: this.state.vehicleValue,
        whoRequested: this.state.whoRequestedValue,
        cameraView: uniq(camera_vals),
        status: statusValue,
        tabIndex: this.state.tabIndex
      });
    });
  }

  handleParseRequested = value => {
    if (Array.isArray(value)) {
      return value.flatMap(status => {
        if (status === 'requested') {
          return ['created', 'reopened'];
        } 
        
        return status;
      });
    }
  
    return ['created', 'reopened'];
  }

  filterCount() {
    const vehicleCount = this.state.localVehicleValue === '' ? 0 : 1;
    const whoRequestedCount = this.state.whoRequestedValue === '' ? 0 : 1;
    const count = vehicleCount + whoRequestedCount +
      size(this.state.localCameraViewValue) +
      size(this.state.localStatusValue);

    return count;
  }

  renderOption = (option) => {
    let options = [];
    const isChecked = includes(this.state.localStatusValue, option.id);
    options = (
      <MenuItem key={option.id} value={option.id}>
        <Checkbox checked={isChecked} />
        <ListItemText primary={I18n.t(option.name)} />
      </MenuItem>
    );

    return options
  }

  renderStatusValue = value => {
    const getSelectedValue = id => {
      const selected = find(this.state.defaultStatusValue, op => op.id === id);
      if (selected.root) {
        return [];
      }
      return I18n.t(get(selected, 'name', get(selected, 'name')));
    };

    return join(flatMap(value, getSelectedValue), ', ');
  }

  renderOptions = () => {
    return map(this.state.defaultStatusValue, value => this.renderOption(value))
  }

  render() {
    return (
      <div className="viappbar__filtercontOnDemand">
        <IconButton onClick={this.handleOpen} color="inherit" id="filterIcon">
          <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow">
            <Icon color="inherit">filter_list</Icon>
          </Badge>
        </IconButton>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleRequestClose}
          className="libraryfilter"
        >
          <AppBar color="default" style={{alignItems: 'flex-end'}}>
            <Toolbar>
              <IconButton onClick={this.handleRequestClose} color="inherit">
                <Icon color="inherit">close</Icon>
              </IconButton>
              <Typography type="title" color="inherit" className="AbstractLibraryFilters-flex-120 LibraryFilters-flex-119" />
              <Button variant="contained" onClick={this.handleClear} id="filterClear" className="btn btn-secondary">
                {I18n.t('action.clear')}
              </Button>
              <Button variant="contained" color="primary" className="btn btn-primary" onClick={this.handleOnFilter} id="filterApply">
                {I18n.t('action.apply')}
              </Button>
            </Toolbar>
          </AppBar>
          <List style={{marginTop: "60px"}}>
            <ListItem id="mobileVehicleFilter">
              <TextField
                label={I18n.t('page.onDemand.previouslyQueue.fields.vehicle')}
                name="vehicle"
                type="text"
                fullWidth
                value={this.state.localVehicleValue}
                onChange={this.handleVehicle}
              />
            </ListItem>
            <ListItem id="mobileWhoRequestedFilter">
              <TextField
                label={I18n.t('page.onDemand.previouslyQueue.fields.whoRequested')}
                name="whoRequested"
                type="text"
                fullWidth
                value={this.state.localWhoRequestedValue}
                onChange={this.handleWhoRequested}
              />
            </ListItem>
            <ListItem id="mobileCameraViewFilter">
              <FormControl fullWidth>
                <InputLabel id="cameraView">{I18n.t('page.onDemand.previouslyQueue.fields.cameraView')}</InputLabel>
                <Select
                  label="cameraView"
                  name="cameraView"
                  multiple
                  value={this.state.localCameraViewValue}
                  onChange={this.handleCameraView}
                  renderValue={(selected) =>
                    selected.map(cid => {
                      const channel_item = this.state.defaultCameraViewValue.find((ch) => ch.id == cid);
                      return channel_item && I18n.t(channel_item.name) || "";
                    }).join(", ")
                }
                  MenuProps={MenuProps}
                >
                  {this.state.defaultCameraViewValue.map(cview => (
                    <MenuItem key={cview.id} value={cview.id}>
                      <Checkbox checked={this.state.localCameraViewValue.indexOf(cview.id) > -1}
                      />
                      <ListItemText primary={I18n.t(cview.name)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListItem>
            <ListItem id="mobileStatusFilter">
              <FormControl fullWidth>
                <InputLabel htmlFor="status">{I18n.t('page.onDemand.previouslyQueue.fields.status')}</InputLabel>
                <Select
                  label="status"
                  name="status"
                  id="status"
                  multiple
                  value={this.state.localStatusValue}
                  onChange={this.handleStatus}
                  renderValue={this.renderStatusValue}
                  MenuProps={MenuProps}
                >
                  { this.renderOptions() }
                </Select>
              </FormControl>
            </ListItem>
          </List>
        </Dialog>
      </div>
    );
  }
}
